import { useReadContract } from 'wagmi';
import { QueryOptions } from 'utils/useQueryUtils';
import { balanceQuoterAbi, getOracleDeployment } from 'sfi-oracle-sdk';

export interface AssetsDataQuoted {
  map: Record<`0x${string}`, { balance: bigint; quote: bigint }>;
  balances: readonly bigint[];
  quotes: readonly bigint[];
  quotesTotal: bigint;
}

export const useUserAssetsQuoted = (
  params: {
    userAddress: `0x${string}`;
    quoteAddress: `0x${string}`;
    tokenAddresses: `0x${string}`[];
    chainId: number;
  } & QueryOptions
) => {
  const {
    userAddress,
    quoteAddress,
    tokenAddresses,
    chainId,
    query = {},
  } = params;
  const oracleDeployment = getOracleDeployment(chainId);

  const queryOptions = {
    refetchInterval: 15000,
    staleTime: 15000,
    ...query,
    enabled:
      query.enabled !== false &&
      !!userAddress &&
      !!quoteAddress &&
      !!oracleDeployment &&
      tokenAddresses.length > 0,
  };

  return useReadContract({
    abi: balanceQuoterAbi,
    address: oracleDeployment?.balanceQuoter as `0x${string}`,
    functionName: 'quoteBalancesFor',
    chainId,
    args: [userAddress, quoteAddress, tokenAddresses],
    query: {
      ...queryOptions,
      select: (data): AssetsDataQuoted => {
        return {
          map: tokenAddresses.reduce(
            (acc, address, index) => {
              acc[address] = {
                balance: data[0][index],
                quote: data[1][index],
              };
              return acc;
            },
            {} as Record<string, { balance: bigint; quote: bigint }>
          ),
          balances: data[0],
          quotes: data[1],
          quotesTotal: data[1].reduce((acc, item) => acc + item, BigInt(0)),
        };
      },
    },
  });
};
